import styled from 'styled-components';

import * as text from '@/components/general/TextStyles';

export const FormBox = styled.form`
  width: 100%;

  @media (max-width: ${(props) => props.theme.breakpoints.md}px) {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

export const TextAreaLabel = styled.div`
  ${text.FS17_NOT_CHANGE}
  margin-bottom: 5px;
  align-self: flex-start;
`;

export const TextArea = styled.textarea<{ textareaSmall?: boolean }>`
  ${text.FS17_NOT_CHANGE}
  border: 1px solid ${(props) => props.theme.colors.borderColor};
  border-radius: 16px;
  width: 100%;
  height: ${(props) => (props.textareaSmall ? '150px' : '250px')};
  padding: 15px;
  font-weight: ${(props) => props.theme.weights.regular};
  resize: none;

  @media (max-width: ${(props) => props.theme.breakpoints.md}px) {
    height: ${(props) => (props.textareaSmall ? '150px' : '200px')};
  }
  @media (max-width: ${(props) => props.theme.breakpoints.sm}px) {
    padding: 12px;
  }
`;

export const ImageContainer = styled.div`
  border: ${(props) => props.theme.borderWidth.sm}px solid
    ${(props) => props.theme.colors.black};
  border-radius: ${(props) => props.theme.borderRadius.xss}px;
  height: 300px;
  width: 400px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;

  @media (max-width: ${(props) => props.theme.breakpoints.lg}px) {
    height: 225px;
    max-width: 400px;
    width: 100%;
    flex-direction: column;
  }
`;

export const ImageBoxDesktop = styled.div`
  position: absolute;
  bottom: 0;
  left: 21px;

  @media (max-width: ${(props) => props.theme.breakpoints.lg}px) {
    display: none;
  }
`;

export const ImageBoxMobile = styled.div`
  display: none;
  margin-bottom: 18px;

  @media (max-width: ${(props) => props.theme.breakpoints.lg}px) {
    display: block;
  }
`;

export const Image = styled.img`
  width: 100%;
  object-fit: cover;

  @media (max-width: ${(props) => props.theme.breakpoints.lg}px) {
    width: 100%;
  }
`;

export const Caption = styled.h5`
  text-align: center;
  font-size: ${(props) => props.theme.fontSize.s3}px;
  line-height: ${(props) => props.theme.lineHeight.m2}px;
  font-weight: ${(props) => props.theme.weights.regular};
`;

interface IButtonBox {
  buttonNotCenteredMedium?: boolean;
  smaller?: boolean;
}

export const ButtonBox = styled.div<IButtonBox>`
  margin-top: ${(props: IButtonBox) => (props.smaller ? '20px' : '30px')};
  width: 100%;

  @media (max-width: ${(props) => props.theme.breakpoints.lg}px) {
    ${(props: IButtonBox) => {
      if (!props.buttonNotCenteredMedium) {
        return `
          display: flex;
          justify-content: center;
        `;
      }
    }}
    margin-top: ${(props) => props.theme.spacing.m1}px;
  }
  @media (max-width: ${(props) => props.theme.breakpoints.md}px) {
    display: flex;
    justify-content: center;
  }
  @media (max-width: ${(props) => props.theme.breakpoints.sm}px) {
    margin-top: ${(props: IButtonBox) => (props.smaller ? '30px' : '40px')};
  }

  & button,
  a {
    border-radius: 16px;
    width: ${(props: IButtonBox) => (props.smaller ? '200px' : '100%')};
    height: 56px;
    font-size: 17px;
    text-align: center;

    @media (max-width: ${(props) => props.theme.breakpoints.sm}px) {
      font-size: 15px;
      width: 100%;
    }
  }
`;
